import React from "react";

const DangerTip = ({ message, style }) => (
  <article className={`is-small is-radiusless message ${style ?? "is-danger"}`}>
    <div className="message-header is-radiusless">
      <p className="is-small">Warning</p>
    </div>
    <div className="message-body">{message}</div>
  </article>
);

export default DangerTip;
